import React from 'react';
import { PlusIcon } from 'lucide-react';
export function CampaignsPage() {
  return <div className="p-6" data-id="element-82">
      <div className="flex items-center justify-between mb-6" data-id="element-83">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white" data-id="element-84">
          Campaigns
        </h1>
        <button className="px-6 py-3 rounded-xl bg-purple-600 text-white font-semibold flex items-center gap-2" data-id="element-85">
          <PlusIcon className="w-5 h-5" data-id="element-86" />
          New Campaign
        </button>
      </div>
      <div className="text-gray-600 dark:text-gray-400" data-id="element-87">
        Campaign management coming soon...
      </div>
    </div>;
}